export default function getDateDifferenceInMs(
  date1: Date,
  date2: Date
): number {
  const diffTime = Math.abs(date2.getTime() - date1.getTime());
  return diffTime;
}
